import dayjs from "dayjs";
import { parseAsJson, useQueryState } from "nuqs";
import z from "zod";

import { DATE_PATTERNS } from "@/lib/Mantine";

const DATE_PATTERN = DATE_PATTERNS.GLOBAL.DATE;
const DATE_PATTERN_BR = DATE_PATTERNS.BR.DATE;

export type DateRangeQueryParamsArgs = z.infer<typeof dateRangeQueryParamsSchema>;
export const dateRangeQueryParamsSchema = z
  .object({
    dateRange: z.tuple([z.string().default(dayjs().subtract(7, "days").format(DATE_PATTERN)), z.string().default(dayjs().format(DATE_PATTERN))]).optional()
  })
  .superRefine((data, ctx) => {
    const [minDate, maxDate] = data.dateRange ?? ["", ""];

    // Converte de GLOBAL para BR para validação visual
    const minDateBr = dayjs(minDate, DATE_PATTERN).format(DATE_PATTERN_BR);
    const maxDateBr = dayjs(maxDate, DATE_PATTERN).format(DATE_PATTERN_BR);

    const minDateValue = dayjs(minDateBr, DATE_PATTERN_BR);
    const maxDateValue = dayjs(maxDateBr, DATE_PATTERN_BR);

    if (!data.dateRange) return;

    if (!minDateValue.isValid()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "A data inicial é inválida.",
        path: ["minDate"]
      });
    }

    if (!maxDateValue.isValid()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "A data final é inválida.",
        path: ["maxDate"]
      });
    }

    if (minDateValue.isAfter(maxDateValue)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "A data inicial não pode ser maior que a data final.",
        path: ["minDate"]
      });
    }

    if (maxDateValue.isAfter(dayjs().endOf("day"))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "A data final não pode ser maior que hoje.",
        path: ["maxDate"]
      });
    }

    if (maxDateValue.isBefore(minDateValue)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "A data final não pode ser menor que a data inicial.",
        path: ["maxDate"]
      });
    }
  });

export function useDriverLogsQueryParams() {
  return useQueryState("json", parseAsJson(dateRangeQueryParamsSchema));
}
